/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'

import { trackEvent } from 'utils/googleAnalytics'

import { DashboardItemProps } from '../types'
import { DealStatsContainer } from './DealStats.styled'

function DealStats({
    componentStyle,
    data,
    dealershipName,
}: DashboardItemProps) {
    const [interaction, setInteraction] = useState(false)

    function trackInteraction() {
        if (interaction) return

        trackEvent(
            'Loyalty Dashboard',
            `${data.title}`,
            'dealership',
            dealershipName,
        )

        setInteraction(true)
    }

    return (
        <DealStatsContainer
            componentStyle={componentStyle}
            data-testid="deal-container"
            onMouseEnter={trackInteraction}
        >
            <label>{data.title}</label>
            {data.stats.map((stat: any, index: number) => {
                return (
                    <div key={index} className="stat">
                        <strong>{stat.value}</strong>
                        <span>{stat.label}</span>
                    </div>
                )
            })}
        </DealStatsContainer>
    )
}

export default DealStats
